<template>
    <div
        v-if="isShowMask"
        class="marketing-wx-open-browser-mask"
        @click="closeMask"
    >
        <div class="mask-note">
            <img class="mask-vector" :src="vectorImg" />
            <div class="title-main">点击右上角，选择浏览器打开</div>
            <div class="title-sub">如果浏览器打不开，请到应用商城下载app</div>
        </div>
    </div>
</template>

<script>
  import { stopBodyScroll } from '@/util/dom';
  import vectorImg from '../../../assets/images/vector2x.png';

  export default {
      name: 'marketing-wx-open-browser-mask',
      props: {
          showMask: {
              type: Boolean,
              default: false
          }
      },
      model: {
          prop: 'showMask',
          event: 'update'
      },
      data() {
          return { vectorImg };
      },
      computed: {
          isShowMask: {
              get({ showMask }) {
                  return showMask;
              },
              set(v) {
                  this.$emit('update', v);
              }
          }
      },
      watch: {
          isShowMask(v) {
              v && stopBodyScroll(true);
          }
      },
      methods: {
          closeMask() {
              stopBodyScroll(false);
              this.isShowMask = false;
          }
      }
  };
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.marketing-wx-open-browser-mask {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1001;
    animation: 0.3s fadeIn;
    .mask-note {
        position: relative;
        top: 30 * @layout375;
        width: 100%;
        text-align: center;
        .mask-vector {
            position: relative;
            width: 94 * @layout375;
            left: 100 * @layout375;
            top: -10 * @layout375;
            transform: rotate(-20deg);
        }

        .title-main {
            font-weight: 400;
            font-size: 20 * @layout375;
            line-height: 26 * @layout375;
            color: #ffffff;
        }

        .title-sub {
            margin-top: 8 * @layout375;
            font-weight: 420;
            font-size: 12 * @layout375;
            line-height: 16 * @layout375;
            color: #ffffff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/marketing/components/wx-open-browser-mask.vue